<ul *ngIf="isSlim" class="layout-menu" #slimMenuContainer>
    <ng-container *ngFor="let item of slimModel; let i = index">
        <li app-menuitem *ngIf="!item.separator" [item]="item" [index]="i" [root]="true"></li>
        <!-- <li>
            <a [uiSref]="item.uiSref">
                <i [class]="item.icon"></i>
                <span>{{ item.label }}</span>
            </a>
        </li> -->
        <li *ngIf="item.separator" class="menu-separator"></li>
    </ng-container>
</ul>

<ul *ngIf="!isSlim" class="layout-menu" #menuContainer>
    <ng-container *ngFor="let item of model; let i = index">
        <li app-menuitem *ngIf="!item.separator" [item]="item" [index]="i" [root]="true"></li>
        <!-- <li>
            <a [uiSref]="item.uiSref">
                <i [class]="item.icon"></i>
                <span>{{ item.label }}</span>
            </a>
        </li> -->
        <li *ngIf="item.separator" class="menu-separator"></li>
    </ng-container>
</ul>
